import React, { Component } from 'react'
import { AppContext } from "@lightspeed-invoicing/core-client/frontend";

class OrderStatusBadge extends Component {

    constructor(props, context) {
        super(props, context);
        this.statusId = this.props.statusId
        this.className = this.props.className || ''
        this.customStyle = this.props.style || {}
        this.status = this.props.status || null
    }

    componentWillReceiveProps(nextProps) {
        this.status = nextProps.status || null
    }

    getBadge(status) {
        switch (status) {
        case "draft":
            return "badge-primary"
        case "ordered":
            return "badge-warning"
        case "completed":
            return "badge-success"
        default:
            return ""
        }
    }

    renderStatus() {
        let status = this.status
        let statusName = status
        let badgeClassname = this.getBadge(status)

        if (!status) {
            status = AppContext.getOrderStatusById(this.statusId)
            if (!status) {
                return <span/>
            }

            badgeClassname = this.getBadge(status.attributes.type)
            statusName = status.attributes.name
        } else if (status.attributes) {
            badgeClassname = this.getBadge(status.attributes.type)
            statusName = status.attributes.name
        }

        return <span className={`badge ${badgeClassname}`}>
            {statusName}
        </span>
    }

    render() {
        return <span className={this.className} style={this.customStyle}>
            {this.renderStatus()}
        </span>
    }

}

export default OrderStatusBadge





// WEBPACK FOOTER //
// ./src/order/status.component.jsx